import React from 'react'
import './Buttons.css'

export const RetryButton = () => {
    const retry = () => window.location.reload();
    return (
        <button className='button' onClick={retry}><i class="fas fa-refresh"></i></button>
    )
}
